<div class="carrier-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="carrier" name="carrier" maxlength="255"
                placeholder="{{'carrier' | translate: ['tmc-yard.entity.transport.carrier', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>